import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HelpCenterChat } from "./HelpCenterChat";
import { cn } from "@/lib/utils";

interface HelpCenterButtonProps {
  userPlan?: string;
  className?: string;
  variant?: "floating" | "inline";
}

// Páginas onde o ConselhoSentinela já está ativo (não mostrar HelpCenterButton flutuante)
const PAGES_WITH_CONSELHO = ["/dashboard", "/relatorio"];

export function HelpCenterButton({ 
  userPlan = "free", 
  className,
  variant = "floating" 
}: HelpCenterButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Verificar se estamos em uma página onde o ConselhoSentinela já está ativo
  const isConselhoActive = PAGES_WITH_CONSELHO.some(page => 
    location.pathname.startsWith(page)
  );

  if (variant === "inline") {
    return (
      <>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsOpen(true)}
          className={cn("gap-2", className)}
        >
          <HelpCircle className="h-4 w-4" />
          Precisa de ajuda?
        </Button>
        <HelpCenterChat 
          isOpen={isOpen} 
          onClose={() => setIsOpen(false)} 
          userPlan={userPlan}
        />
      </>
    );
  }

  // Não renderizar botão flutuante em páginas com ConselhoSentinela
  if (isConselhoActive) {
    return null;
  }

  return (
    <>
      <Button
        onClick={() => setIsOpen(!isOpen)}
        size="icon"
        aria-label="Abrir central de ajuda"
        className={cn(
          "fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-40",
          "bg-primary hover:bg-primary/90 text-primary-foreground",
          "transition-transform hover:scale-105",
          className
        )}
      >
        <MessageCircle className="h-6 w-6" aria-hidden="true" />
      </Button>
      <HelpCenterChat 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)} 
        userPlan={userPlan}
      />
    </>
  );
}
